(function() { window.GUID_03505635_6317_412e_8bb1_46128a887b2d = { getGuid: function() { return "03505635-6317-412e-8bb1-46128a887b2d"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ProgressBar extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                const me = this;
                me.controlId = params[0];
                me.$control = $('#' + params[0]);
                me.$background = me.$Control.find(".background");
                me.$progress = me.$Control.find(".progress");
                me.value = params[1];
                me.range = params[2];
                const fillPercentage = Math.round(me.value * 100 / me.range);
                me.$progress.css({
                    width: `${fillPercentage}%`
                });
            }
            OnBindEvents() {
            }
            OnDispose() {
            }
        }
        Controls.ProgressBar = ProgressBar;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=progress-bar.js.map
